<template>
    <div v-b-tooltip.hover class="carousel-item-root clickable" :title="title" @click="click">
        <img
            ref="img"
            :src="img"
            style="height: 120px; width: calc(100% - 40px); padding: 20px 0; object-fit: contain;"
        />
        <br />
        <!--<div style="font-size: 14px; line-height: 40px; height: 40px;">
            {{ title }}
        </div>-->
        <country-flag :country="country" size="normal" />
    </div>
</template>

<script>
import CountryFlag from 'vue-country-flag';

export default {
    name: 'Carousel.Default',
    components: { CountryFlag },
    props: {
        country: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: 'normal',
        },
        title: String,
        click: Function,
        img: { type: String, default: '' },
    },
    data() {
        return {
            imgHeight: 100,
            height: 500,
        };
    },

    methods: {
        handleResizeEvent() {
            this.imgHeight = this.$refs.img.clientWidth;
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleResizeEvent);
        });
        this.handleResizeEvent();
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResizeEvent);
    },
};
</script>

<style lang="css" scoped>

.carousel-item-root > img {
    width: 100%;
    object-fit: cover;
}
</style>
